import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import BookingLayout from 'pages/booking/BookingLayout';
import { useApi } from 'api/api-context';
import useLang from 'lang';
import { BOOKING_LOGIN_PATH } from 'routes/paths';
import 'pages/booking/booking-auth-form.css';

/** Confirm a booking-account email change without requiring an authenticated browser. */
export default function BookingEmailChange() {
  const [params] = useSearchParams();
  const { request } = useApi();
  const { _t } = useLang();
  const [state, setState] = useState<'loading' | 'success' | 'error'>('loading');
  const submittedToken = useRef<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setState('error');
      return;
    }
    if (submittedToken.current === token) return;
    submittedToken.current = token;
    request({ method: 'POST', url: '/reservations/account/email-change/confirm', data: { token } })
      .then(() => setState('success'))
      .catch(() => setState('error'));
  }, [params, request]);

  return (
    <BookingLayout>
      <main className="booking-auth-page">
        <section className="booking-auth-card">
          <h1>{_t('Change email')}</h1>
          {state === 'loading' && <p>{_t('Confirming...')}</p>}
          {state === 'success' && (
            <>
              <p role="status">{_t('Your email address has been changed.')}</p>
              <Link to={BOOKING_LOGIN_PATH.original}>{_t('Log in')}</Link>
            </>
          )}
          {state === 'error' && (
            <p role="alert" className="booking-auth-error">
              {_t('This email confirmation link is invalid or expired.')}
            </p>
          )}
        </section>
      </main>
    </BookingLayout>
  );
}
